import { autoserialize, inheritSerialization } from 'cerialize';
import { Document } from './document';

@inheritSerialization(Document)
export class DocumentDetail extends Document {
  @autoserialize
  status: string;

  @autoserialize
  reviewedBy: string;
}
